import { Action, MapDevices } from '@/OptimusRoutes/components/mapDevices/actions';
import { ActionType } from '@/types/actionType';

type State = {
	devices: MapDevices;
};

const initialState: State = {
	devices: {},
};

const reducer = (state: State = initialState, action: Action): State => {
	switch (action.type) {
		case ActionType.MAP_DEVICES_SET_DEVICES:
			return {
				...state,
				devices: action.payload as MapDevices,
			};
		case ActionType.MAP_DEVICES_UPDATE_DEVICE:
			return {
				...state,
				devices: {
					...state.devices,
					...{ [action.payload.id]: { ...state.devices[action.payload.id], ...action.payload.data } },
				},
			};
		case ActionType.MAP_DEVICES_CLEAR_DEVICES:
			return {
				...state,
				devices: {},
			};
		default:
			return state;
	}
};

export default reducer;
